const parseFlag = (value: unknown): boolean => {
  if (typeof value !== 'string') {
    return false;
  }
  return ['1', 'true', 'yes', 'on'].includes(value.trim().toLowerCase());
};

const isEnabledByDefault = (value: unknown): boolean =>
  String(value ?? 'true').trim().toLowerCase() !== 'false';

export const uiFlags = {
  // Default ON for the enterprise shell. Set VITE_ENABLE_ENTERPRISE_SHELL=false to disable.
  enableEnterpriseShell: !parseFlag(import.meta.env.VITE_DISABLE_ENTERPRISE_SHELL) &&
    isEnabledByDefault(import.meta.env.VITE_ENABLE_ENTERPRISE_SHELL),
};
